(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityFieldCustomSelect', activityFieldCustomSelect);

    function activityFieldCustomSelect(lodash, FbSelectService) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                element: '=',
                title: '=?',
            },
            templateUrl: 'common/app/components/activities/activity-input/fields/custom-select',
            link: function (scope, elem, attr, ctrl) {
                scope.fieldConfig = {};
                const additionalOptions = {};
                scope.element.placeholder = '';
                scope.fieldConfig.ds = angular.copy(lodash.get(scope.element, 'datasource.data', []));

                FbSelectService.initTemplateCall(scope.element.options, additionalOptions);

                scope.fieldConfig =
                    angular.merge(
                        {
                            highlight: true,
                            create: false,
                            labelField: 'label',
                            valueField: 'value',
                            maxItems: 1,
                            searchField: ['label'],
                            plugins: ['remove_button'],
                            placeholder: 'test',
                            onIntialize: function() {
                                //$element.find('')
                            },
                            onChange: function() {

                            }
                        },
                        lodash.get(scope.element, 'options', {}),
                        additionalOptions
                    );

            }
        };
    }
})();